export default "__VITE_ASSET__DbtZS1n___"